var _a;
import { Categories } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Categories.DrugCovered] = 'Drug covered',
    _a[Categories.DrugNotCovered] = 'Drug not covered',
    _a[Categories.PrescriptionNoRefill] = 'Prescription no refill',
    _a[Categories.PrescriptionPriorAuth] = 'Prescription prior auth',
    _a[Categories.PrescriptionRefillPending] = 'Prescription refill pending',
    _a[Categories.PrescriptionTransferPharmacy] = 'Prescription transfer pharmacy',
    _a[Categories.Unknown] = 'Unknown',
    _a);
export var CategoriesEnum = {
    name: 'Categories',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
